import { array, boolean, defineAction, number, object, string } from '~/prix'
import variableAnalyzeAction from './variableAnalyze.action.json' with { type: 'json' }

const variableAnalyzeDefinition = defineAction({
  ...variableAnalyzeAction,

  input: object({
    full: boolean(),
    sectorFilter: array(string()).label('Filtros de setor'),
    concurrency: number().label('Concorrência'),
    filterGlob: string().label('Filtro usando glob'),
  }),
  output: object({}),
})

export default variableAnalyzeDefinition
